import { NgModule } from '@angular/core';
import { ModalHelper } from './modal-helper';
import { ModalNavigatorDirective } from './modal-navigator-anchor.directive';
import { ModalNavigatorComponent } from './modal-navigator.component';

@NgModule({
  imports: [],
  exports: [],
  providers: [ModalHelper],
  declarations: [ModalNavigatorComponent, ModalNavigatorDirective],
})
export class ModalNavigatorModule {}
